// ** React Imports
import React, {Fragment, useEffect, useState} from 'react'

// ** Table Data & Columns
import { columns } from './data'

// ** Third Party Components
import ReactPaginate from 'react-paginate'
import DataTable from 'react-data-table-component'
import {ChevronDown, UploadCloud} from 'react-feather'

// ** Reactstrap Imports
import {
    Row,
    Col,
    Card,
    Input,
    Label,
    CardTitle,
    CardHeader, Button, ModalHeader, ModalBody, Modal, Spinner, CardText
} from 'reactstrap'

// ** Styles
import '@styles/react/libs/tables/react-dataTable-component.scss'
import axios from "axios";
import moment from "moment";
import UploadTemplate from "./components/upload-template/upload-template";

const TemplateList = () => {
    // ** States
    const [showUploadModal, setShowUploadModal] = useState(false);
    const [currentPage, setCurrentPage] = useState(0)
    const [searchValue, setSearchValue] = useState('')
    const [data, setData] = useState([])
    const [filteredData, setFilteredData] = useState(data)

    const toggleUploadModal = (show) => {
        setShowUploadModal(show);
    }

    const getTemplates = async () => {
        const response =  await axios.get(`${process.env.REACT_APP_API_URL}/templates`)
        const templatesList = response?.data.map((item) => {
            return {
                noTemplate: item.id,
                templateName: item.name,
                createDate:  moment().format("DD/MM/YYYY"),
                urlDocument: item.urlDocument
            }
        });
        setData(templatesList);
    }

    useEffect(() => {
        getTemplates();
    }, []);


    // ** Function to handle filter
    const handleFilter = e => {
        const value = e.target.value
        let updatedData = []
        setSearchValue(value)

        if (value.length) {
            updatedData = data.filter(item => {

                const startsWith =
                    item.noTemplate.toString().toLowerCase().startsWith(value.toLowerCase()) ||
                    item.templateName.toLowerCase().startsWith(value.toLowerCase()) ||
                    item.createDate.toLowerCase().startsWith(value.toLowerCase()) ||
                    item.templateUrl.toLowerCase().startsWith(value.toLowerCase())

                const includes =
                    item.noTemplate.toString().toLowerCase().includes(value.toLowerCase()) ||
                    item.templateName.toLowerCase().includes(value.toLowerCase()) ||
                    item.createDate.toLowerCase().includes(value.toLowerCase()) ||
                    item.templateUrl.toLowerCase().includes(value.toLowerCase())

                if (startsWith) {
                    return startsWith
                } else if (!startsWith && includes) {
                    return includes
                } else return null
            })
            setFilteredData(updatedData)
            setSearchValue(value)
        }
    }

    // ** Function to handle Pagination
    const handlePagination = page => {
        setCurrentPage(page.selected)
    }

    // ** Pagination Previous Component
    const Previous = () => {
        return (

            <Fragment>
                <span className='align-middle d-none d-md-inline-block'>Anterior</span>
            </Fragment>
        )
    }

    // ** Pagination Next Component
    const Next = () => {
        return (
            <Fragment>
                <span className='align-middle d-none d-md-inline-block'>Siguiente</span>
            </Fragment>
        )
    }

    // ** Custom Pagination
    const CustomPagination = () => (
        <ReactPaginate
            previousLabel={<Previous />}
            nextLabel={<Next />}
            forcePage={currentPage}
            onPageChange={page => handlePagination(page)}
            pageCount={searchValue.length ? Math.ceil(filteredData.length / 20) : Math.ceil(data.length / 20) || 1}
            breakLabel={'...'}
            pageRangeDisplayed={2}
            marginPagesDisplayed={2}
            activeClassName={'active'}
            pageClassName={'page-item'}
            nextLinkClassName={'page-link'}
            nextClassName={'page-item next'}
            previousClassName={'page-item prev'}
            previousLinkClassName={'page-link'}
            pageLinkClassName={'page-link'}
            breakClassName='page-item'
            breakLinkClassName='page-link'
            containerClassName={'pagination react-paginate pagination-sm justify-content-end pe-1 mt-1'}
        />
    )

    return (<Fragment>
            <Card>
                <CardHeader className='flex-md-row flex-column align-md-items-center align-items-start border-bottom'>
                    <CardTitle tag='h4'>Plantillas</CardTitle>
                </CardHeader>

                <Row className='justify-content-end mx-0'>
                    <Col className='d-flex justify-content-end mt-1' md='6' sm='12'>
                        <Button
                            onClick={() => toggleUploadModal(true)}
                            color='primary'
                            className='btn-sm'>
                            <UploadCloud size={16} />
                            <span className={'ms-1'}>Cargar plantilla</span>
                        </Button>
                    </Col>
                </Row>
                < hr/>
                <Row className='justify-content-end mx-0'>
                    <Col className='d-flex align-items-center justify-content-end mt-1' md='6' sm='12'>
                        <Label className='me-1' for='search-input'>
                            Buscar
                        </Label>

                        <Input
                            className='dataTable-filter mb-50'
                            type='text'
                            bsSize='sm'
                            id='search-input'
                            value={searchValue}
                            onChange={handleFilter}
                        />
                    </Col>
                </Row>
                    <div className='react-dataTable'>
                        <DataTable
                            noHeader
                            pagination
                            columns={columns}
                            paginationPerPage={20}
                            className='react-dataTable'
                            sortIcon={<ChevronDown size={10} />}
                            paginationComponent={CustomPagination}
                            paginationDefaultPage={currentPage + 1}
                            data={searchValue.length ? filteredData : data}
                        />
                    </div>
            </Card>
            <Modal
                isOpen={showUploadModal}
                toggle={() => toggleUploadModal(false)}
                className={`modal-dialog-centered `}
            >
                <ModalHeader toggle={() => toggleUploadModal(false)}>
                    Cargar plantilla
                </ModalHeader>
                <ModalBody>
                    <UploadTemplate onClose={toggleUploadModal} />
                </ModalBody>
            </Modal>
        </Fragment>
    )
}

export default TemplateList
